import { InteractionInfo } from './InteractionInfo';
import { DatosPersonales } from './DatosPersonales';
import { DatosEmpresa } from './DatosEmpresa';
import { NavigationHistory } from './NavigationHistory';
import { FormElements } from './FormElements';

export class Contexto {

    // servicio donde se instancia el asistente
    public idServicio: string;
    // codigo del asistente a dibujar. Permite dibujar diferentes asistentes en un mismo servicio en línea
    public codAsistente: string;
    public descServicio: string;
    public datosEmpresa: DatosEmpresa;
    public interactionInfo: InteractionInfo;
    public datosPersonales: DatosPersonales;
    public persIdentificador: number;
    // A la fecha (Feb 7, 2022) codigoTema se mapea con el concepto de "codigoTemaDestinatario"
    public codigoTema:string;
    // Etiqueta se inyecta para que la consuma el formulario de asistencia;
    // puede ser el nombre de un nodo del arbol o una etiqueta inyectada desde fuera (ej: nombre de un servicio en linea)
    public etiquetaTema:string;
    public idMenu: string;

    // Es el id de Formulario asociado al Menu (configurado en el aliss-bkend-concierge.xml)
    public idFormAsociado: string;

    // codigo del nodo del arbol donde se solicita asistencia
    public codigoNodoArbol:string;
    // Etiqueta del nodo del arbol donde se solicita asistencia (ejemplo formulario)
    public etiquetaNodoArbol:string;

    // navigationHistory = informacion del handler utilizado anteriormente
    public navigationHistory: NavigationHistory;

    public esFormulario: boolean;

    public formElements: FormElements;

    constructor() {
        this.interactionInfo = new InteractionInfo();
        this.datosPersonales = new DatosPersonales();
        this.datosEmpresa = new DatosEmpresa();
        this.navigationHistory = new NavigationHistory();
        this.formElements = new FormElements();
  	}
}
